export const REMOTE_DEVICE_COMMAND = import.meta.env.VITE_REMOTE_DEVICE_COMMAND || "npx @wonderwhy-er/desktop-commander@latest remote";

export const MCP_CONNECTOR_URL = "https://mcp.desktopcommander.app/mcp";

export const CHATGPT_CONNECTOR_URL = "https://chatgpt.com/apps/remote-desktop-commander/asdk_app_6a057d268ebc81919918d37eec718425";

export const CLAUDE_CONNECTOR_URL = "https://claude.ai/directory/connectors/218bbf02-d0dd-4aa9-8bdd-06bb2a8589af";

/** Tally forms behind the dashboard fake doors. Prefilled through their hidden fields. */
export const TEAM_PLAN_FORM_URL = "https://tally.so/r/A7ojRD";
export const DEVICE_SHARE_FORM_URL = "https://tally.so/r/LZAkGp";
export const HOSTED_SERVER_FORM_URL = "https://tally.so/r/J9aMeJ";
